export default "__VITE_ASSET__Cgj_JaAt__"